// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.p-dropdown-panel .p-dropdown-items-wrapper {
  max-height: 200px;
}

:host ::ng-deep .p-dropdown-panel .p-dropdown-items-wrapper {
  max-height: 220px;
}`, "",{"version":3,"sources":["webpack://./src/app/add-order/add-order.component.scss"],"names":[],"mappings":"AAAA;EACI,iBAAA;AACJ;;AACA;EACI,iBAAA;AAEJ","sourcesContent":[".p-dropdown-panel .p-dropdown-items-wrapper {\n    max-height: 200px;\n}\n:host ::ng-deep .p-dropdown-panel .p-dropdown-items-wrapper {\n    max-height: 220px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
